/**
 * This exception is used when a method isn't implemented yet.
 */
export class NotImplementedException extends Error {
  constructor(message = "Not implemented") {
    super(message);
  }
}
